// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"85f53210","195":"fb724051","338":"449afcf6","453":"7e1abe35","463":"fe950a5a","584":"fcc24e96","606":"f7993741","651":"699a8440","767":"bc700712","844":"6a69ae3e","889":"8576c21f","929":"6cc22595","980":"fe5b8ed7"}[chunkId] + ".chunk.js";
};